import React, {useState, useRef, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

import { DropDownField, TextInputField, CheckboxField, AutoCompleteField, MultiSelectField } from "../../../helpers";
import Button from "../../../helpers/Button";
import { Menu } from 'primereact/menu';

import { utils, write } from "xlsx";
import Papa from "papaparse";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";

import { fetchPettyCash, updateSearchParams, updateSearchOptions, setSearchConfig } from "../../../services/redux/reducers/pettycash/pettycash";
import { searchPettyCashes } from "../../../services/api/pettyCash";

import { checkPermissions, getAutoSearchSuggestions, getFullName, getDateString, getMatchedRegexPattern, normalizeLabel, numberConversion, useFuzzSearch, getAddFilterOptions, getDateRange } from "../../../utils";
import { fetchPettyCashCategories } from "../../../services/redux/reducers/commonThunk";
import Loading from "../../../common/Loading";
import moment from "moment";

import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";
import { fetchMaterialUoms } from "../../../services/redux/reducers/commonThunk";
import DateFilter from "../../../common/DateFilter";
import { DATE_FORMAT } from "../../../constants";


let pettycashSearchConfig = [
    {
        srNO: 1,
        static: true,
        type: "SELECT",
        name: "dataType",
        label: "Data type",
        options: [
            { label: 'PettyCash Data', value: 'pettycashData' }
        ]
    },
    {   srNO: 2,
        static: true,
        type: "SEARCH_TEXT",
        name: "searchText",
        label: "Search Text",  
    },
    // {
    //     srNO: 3,
    //     static: true,
    //     type: "SEARCH_BY",
    //     name: "searchBy",
    //     label: "Search by",
    //     options: [
    //         { label: 'No Filters', value: 'all' },
    //         { label: 'KAM Name', value: 'userId'},
    //         { label: 'Booked By', value: 'bookedBy'},
    //         { label: 'Amount', value: 'amount'},
    //         { label: 'Description', value: 'description'},
    //         { label: 'Nature Of Expense', value: 'Nature Of Expense' },
    //         { label: 'Transaction No', value: 'Transaction No' },
    //         { label: 'Voucher No', value: 'voucherNo' },
    //         { label: 'Vendor Payment No.', value: 'vendorPaymentNo' },
    //     ]
    // },
   
    {
        srNO: 3,
        static: true,
        type: "DATE",
        name: "dateType",
        label: "Date",
        options: [
            { label: 'Created Date', value: 'createdAt' },
            { label: 'Transaction Date', value: 'transactionDate' }
        ]
    },
    {
        srNO: 4,
        static: false,
        type: "SELECT",
        name: "bookedStatus",
        label: "Booked Status",
        options: [
            { label: 'Booked', value: true },
            { label: 'UnBooked', value: false }
        ]
    },
    {
        srNO: 5,
        static: false,
        type: "SELECT",
        name: "pettyCashType",
        label: "Petty Cash type",
        options: [
            { label: 'REQUEST', value: 'REQUEST' },
            { label: 'EXPENSE', value: 'EXPENSE' }
        ]
    },
    {
        srNO: 7,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "docNo",
        label:"Transaction No",
    },
    {
        srNO: 8,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "voucherNo",
        label:"Voucher No",
    },
    {
        srNO: 9,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "vendorPaymentNo",
        label:"Vendor Payment No.",
    },
    {
        srNO: 10,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "AUTO_COMPLETE",
        name: "kamName",
        label:"Kam Name",
        priority: 1
    },
    {
        srNO: 11,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "bookedBy",
        label:"Booked By",
    },
    {
        srNO: 12,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "amount",
        label:"Amount",
    },
    {
        srNO: 13,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "description",
        label:"Description",
    },
    {
        srNO: 14,
        static: false,
        removable: true,
        type: "MULTISELECT",
        name: "pettyCashCategoryIds",
        label:"Nature Of Expense",
    }
]

const Search = (props) => {
    const { pettyCash, pettyCashAccount, pettyCashAccountsDetails, getOpeningAndClosingBalances, setOpeningBalance, setClosingBalance, pettyCashUsers } = props
   
    const [suggestions, setSuggestions] = useState([])
    const [loading, setIsLoading] = useState(false)
    const [kamSuggestions, setKAMSuggestions] = useState([])

    const userDetails = useSelector(state => state.userDetails)
    const isLoading = useSelector(state => state.pettyCash.loading)
    const paginationParams = useSelector(state => state.pettyCash.paginationParams)
    const searchParams = useSelector(state => state.pettyCash.searchParams)
    const searchOptions = useSelector(state => state.pettyCash.searchOptions)
    const pettyCashCategories = useSelector(state => state.common.pettycashCategories)
    const uomsData = useSelector(state => state.common.materialUOMs)
    const usersData = useSelector(state => state.userDetails)

    const pmCompanyConfig = getPMCompanyConfig(usersData.PMCompanyDetails.companyId)
    let { numberLocale } = pmCompanyConfig

    const searchConfig = [...pettycashSearchConfig]

    const filterMenu = useRef(null)
    const downloadMenu = useRef(null)
    const searchTextRef = useRef(null)

    const dispatch = useDispatch()

    let pmCompanyUsers = userDetails.PMCompanyDetails.companyUsers ? userDetails.PMCompanyDetails.companyUsers : []

    pmCompanyUsers = pettyCashUsers.map(eachPerson => {
        return {...eachPerson, displayName: eachPerson.name}
    })

    useEffect(() => {
        dispatch(setSearchConfig(pettycashSearchConfig))
        dispatch(fetchPettyCashCategories())
        dispatch(fetchMaterialUoms())
        if(searchOptions.length === 0){
            const filteredSearchOptions = searchConfig.filter(eachOption => eachOption.static)
            dispatch(updateSearchOptions(filteredSearchOptions))
        }
    }, [])

    useEffect(() => {
        const {isPermitted: isAccountSearchPermitted} = checkPermissions({...usersData, permissions: [181]})
        if (isAccountSearchPermitted){
            const accountSearchConfig = pettycashSearchConfig.find(eachSearchConfig => eachSearchConfig.name === "account")
            if (!accountSearchConfig){
                pettycashSearchConfig = [...pettycashSearchConfig, {
                    srNO: 6,
                    static: false,
                    type: "SELECT",
                    name: "account",
                    label: "Account",
                    removable: true
                }]
            }
        }
    }, [usersData])

    useEffect(() => {
        if (searchTextRef.current) {
            searchTextRef.current.focus()
        }
    }, [searchParams.searchBy])

    useEffect(() => {
        if (['kamName'].includes(searchParams.searchBy)) {
            autoCompleteSearch(searchParams.searchBy, searchParams.searchText)
        }
    }, [searchParams.searchBy])

    const kamFuzzSearch = useFuzzSearch(pmCompanyUsers, "displayName")

    const addFilterOption = (srNO) => {
        let relatedConfig = searchConfig.find(eachConfig => eachConfig.srNO === srNO)
        let updatedPettyCashAccountsDetails = []
        if (relatedConfig.name === "account"){
            updatedPettyCashAccountsDetails = pettyCashAccountsDetails?.map(eachPettyCashAccountDetail => 
                ({...eachPettyCashAccountDetail, label: eachPettyCashAccountDetail?.pettyCashAccount, value: eachPettyCashAccountDetail?.pettyCashAccountsId})
            )
            updatedPettyCashAccountsDetails = _.sortBy(updatedPettyCashAccountsDetails, "pettyCashAccount")
            relatedConfig = {...relatedConfig, options: updatedPettyCashAccountsDetails}
        }
        if(relatedConfig.name === "pettyCashCategoryIds"){
            const updatedPettyCashCategories = pettyCashCategories?.map(eachPettyCash => ({...eachPettyCash, label: eachPettyCash.pettyCashCategoryName, value: eachPettyCash.pettyCashCategoryId}))
            relatedConfig = {...relatedConfig, options: updatedPettyCashCategories}
        }
        dispatch(updateSearchOptions([...searchOptions, relatedConfig]))
    }

    const removeFilterOption = (srNO) => {
        const relatedSearchOption = searchOptions.find(eachOption => eachOption.srNO === srNO)
        const updatedSearchParams = {...searchParams}

        if(relatedSearchOption.type === "SEARCH_BY"){
            updatedSearchParams.searchText = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if(relatedSearchOption.type === "DATE"){
            updatedSearchParams.fromDate = null
            updatedSearchParams.toDate = null
            updatedSearchParams.range = ""
            setClosingBalance("")
            setOpeningBalance("")
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if(relatedSearchOption.type === "SELECT"){
            if (relatedSearchOption.name === "account" && searchParams?.searchBy !== "kamName"){
                updatedSearchParams["account"] = null
                // dispatch(updateSearchParams(updatedSearchParams))
            }
            else if(relatedSearchOption.name === "account" && searchParams.searchBy === "kamName"){
                const relatedPettyCashUser = pettyCashUsers.find(eachUser => eachUser.name.trim() === searchParams.searchText.trim())
                if(relatedPettyCashUser){
                    updatedSearchParams["account"] = relatedPettyCashUser.pettyCashAccountId
                }
                else{
                    updatedSearchParams["account"] = null
                }
            }
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if (relatedSearchOption.type === "TEXT") {
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if (relatedSearchOption.type === "AUTO_COMPLETE") {
            updatedSearchParams[relatedSearchOption.name] = ""
            if (relatedSearchOption.name === "kamName"){
                updatedSearchParams["account"] = null
            }
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if (relatedSearchOption.type === "MULTISELECT") {
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }

        console.log("related", relatedSearchOption)

        const filteredSearchOptions = searchOptions.filter(eachOption => eachOption.srNO !== srNO)
        dispatch(updateSearchOptions([...filteredSearchOptions]))
    }

    const handleSearchOnChange = (event) => {
        let eventValue = event.target.value

        if (eventValue && (eventValue.userId || eventValue.companyId)) {
            eventValue = eventValue.displayName
        }
      
        let updatedSearchParams = searchParams

        if (searchParams.searchBy === "kamName" && event.target.name === "searchText"){
            updatedSearchParams = {...searchParams, account: event.target.value?.pettyCashAccountId, searchText: eventValue, "kamName": eventValue}
        }else if (event.target.name === "kamName" && eventValue){
            updatedSearchParams = {...searchParams, account: event.target.value?.pettyCashAccountId, [event.target.name]: eventValue}
        }else if (event.target.name === "account"){
            updatedSearchParams = {...searchParams, [event.target.name]: eventValue}
        }else{
            updatedSearchParams = {...searchParams, [event.target.name]: eventValue}
        }

        if(event.target.name === "searchText"){
            const availableOptions = [...pettycashSearchConfig]
            const matchText = eventValue.split(";")[0]
            const matchedPattern = getMatchedRegexPattern(matchText, availableOptions, searchParams.searchBy)
            updatedSearchParams.searchBy = matchedPattern
        }

        if (eventValue instanceof Date) {
            if(new Date(searchParams[event.target.name])?.getTime() != eventValue.getTime()){
                updatedSearchParams.range = null
            }

            if (event.target.name === "toDate") {
                eventValue.setHours(23, 59, 0, 0)
            }
            if (event.target.name === "fromDate") {
                eventValue.setHours(0, 0, 0, 0)
            }
            eventValue = eventValue.toISOString()

            updatedSearchParams[event.target.name] = eventValue
        }

        dispatch(updateSearchParams(updatedSearchParams))
    }

    const autoCompleteSearch = (searchType, query) => {        
        const suggestions = getAutoSearchSuggestions({
            searchType,
            query,
            pmCompanyUsers,
            kamFuzzSearch,
        })
        
        setSuggestions(suggestions)
    }

    const addFilterOptions = getAddFilterOptions(searchConfig, searchOptions, searchParams, addFilterOption)

    const constructPettyCashData = (pettycashData, pettyCashItems, bookingLogs) =>{
        let pettyCashes = []
        for (let i = 0; i < pettycashData.length; i++) {
            let counter = i + 1

            let pettyCash = pettycashData[i]

            let bookedDate = ""
            let transactionDate = ""
            let pettyCashDate = ""

            const relatedBookingLog = bookingLogs.find(eachBookingLog => eachBookingLog.docNo === pettyCash.docNo)
            if(relatedBookingLog?.bookedAt){
                bookedDate = moment(relatedBookingLog.bookedAt).format(DATE_FORMAT)
            }

            if(pettyCash.transactionDate){
                transactionDate = moment(pettyCash.transactionDate).format(DATE_FORMAT)
            }

            if(pettyCash.createdAt){
                pettyCashDate = moment(pettyCash.createdAt).format(DATE_FORMAT)
            }

            let kamName = getFullName(pettyCash["users.firstName"], pettyCash["users.lastName"])
            let amount = ''
            if(pettyCash.entryType === "REQUEST"){
                amount = `${numberConversion(pettyCash.amount, numberLocale)}`
            }else{
                amount = `- ${numberConversion(pettyCash.amount, numberLocale)}`
            }

            const pettyCashId = pettyCash.pettyCashId
            let natureOfExpenseStrList = []
            let pettyCashItemCategoryIds = []
            pettyCashItems?.filter((eachPettyCashItem) => {
                if(eachPettyCashItem.pettyCashId === pettyCashId){
                    pettyCashItemCategoryIds.push(eachPettyCashItem.pettyCashCategoryId)
                }
            })
            if(pettyCashItemCategoryIds.length > 0){
                pettyCashItemCategoryIds?.map((eachCategoryId) => {
                    const pettyCashCategoryResult =  pettyCashCategories?.find(eachCategory => eachCategory.pettyCashCategoryId === eachCategoryId)
                    natureOfExpenseStrList.push(pettyCashCategoryResult?.pettyCashCategoryName)
                })
            }
            let natureOfExpense = natureOfExpenseStrList.join(", ")

            const relatedPettyCashItems = pettyCashItems?.filter(eachPettyCashItem => eachPettyCashItem?.pettyCashId === pettyCash?.pettyCashId)
            let descriptionArr = []
            relatedPettyCashItems?.map(eachPettyCashItem => descriptionArr.push(eachPettyCashItem?.prodDesc))
            let descriptionStr = descriptionArr.join(", ")

            const relatedPettyCashAccount = pettyCashAccountsDetails?.find(eachPettyCashAccountDetail => eachPettyCashAccountDetail?.pettyCashAccountsId === pettyCash?.pettyCashAccount)

            const downloadObj = {
                'Sr. No.': counter,
                'Petty Cash No.': pettyCash?.docNo,
                'Vendor Payment No.': pettyCash["vendorPayment.docNo"],
                'Account': relatedPettyCashAccount?.pettyCashAccount,
                'KAM': kamName,
                'Petty Cash Type': pettyCash?.entryType,
                'Nature Of Expense': natureOfExpense,
                'Description': descriptionStr,
                'Supporting Documents': pettyCash?.documentType,
                'Amount': amount,
                'Booked Date': bookedDate,
                'Transaction Date': transactionDate,
                'Pettycash Date': pettyCashDate
            }
            pettyCashes.push(downloadObj)
        }
        return pettyCashes

    }

    const constructProductData = (pettycashData, pettyCashItems, bookingLogs) => {
        let productDownloadData = []
        let itemCounter = 1

        pettyCashItems.map(eachPettyCashItem => {
            const relatedPettyCash = pettycashData.find(eachPettyCash => eachPettyCash.pettyCashId === eachPettyCashItem.pettyCashId)
            const relatedPettyCashAccount = pettyCashAccountsDetails.find(eachPettyCashAccountDetail => eachPettyCashAccountDetail.pettyCashAccountsId === relatedPettyCash.pettyCashAccount)
            let kamName = getFullName(relatedPettyCash["users.firstName"], relatedPettyCash["users.lastName"])
            let bookedDate = ""
            let transactionDate = ""
            let pettyCashDate = ""
    
            const relatedBookingLog = bookingLogs.find(eachBookingLog => eachBookingLog.docNo === relatedPettyCash.docNo)
            if (relatedBookingLog?.bookedAt) {
                bookedDate = getDateString(relatedBookingLog.bookedAt, "DD.MM.YYYY")
            }
    
            if (relatedPettyCash.transactionDate) {
                transactionDate = getDateString(relatedPettyCash.transactionDate, "DD.MM.YYYY")
            }
            if (relatedPettyCash.createdAt) {
                pettyCashDate = getDateString(relatedPettyCash.createdAt, "DD.MM.YYYY")
            }

            const relatedCategory = pettyCashCategories.find(eachPettyCashCategory => eachPettyCashCategory.pettyCashCategoryId === eachPettyCashItem.pettyCashCategoryId)
            const relatedUom = uomsData.find(eachUOM => eachUOM.materialUOMId === parseInt(eachPettyCashItem.unit))
            const productObj = {
                'Sr. No.': itemCounter++,
                'Petty Cash No.': relatedPettyCash.docNo,
                'Vendor Payment No.': relatedPettyCash["vendorPayment.docNo"],
                'Account': relatedPettyCashAccount.pettyCashAccount,
                'KAM': kamName,
                'Petty Cash Type': relatedPettyCash.entryType,
                'Supporting Documents': relatedPettyCash.documentType,
                'Product Description': eachPettyCashItem.prodDesc,
                'Nature Of Expense': relatedCategory?.pettyCashCategoryName || "",
                'Quantity': eachPettyCashItem.quantity,
                'Unit': relatedUom?.UOM || "",
                'Unit Price': eachPettyCashItem.unitPrice,
                'Product DocNo': eachPettyCashItem.docNo || "N/A",
                'Booked Date': bookedDate,
                'Transaction Date': transactionDate,
                'Pettycash Date': pettyCashDate
            }
            productDownloadData.push(productObj)
        })
    
        return productDownloadData
    }

    const downloadData = async (dataFormat, downloadType) => {
        if(searchParams.onlyMe && !pettyCashAccount?.pettyCashAccountId){
            return
        }

        const updatedSearchParams = { ...searchParams }
        if(updatedSearchParams.searchBy !== "all"){
            updatedSearchParams[updatedSearchParams.searchBy] = updatedSearchParams.searchText.trim()
        }
        
        setIsLoading(true)
        const response = await searchPettyCashes({...searchParams, ...paginationParams, paginator: false, limitedPagination: false})
        setIsLoading(false)

        if (response.failure){
            return dispatch(raiseToast({ severity: 'error', detail: response.data.error, life: 3000 }))
        }

        const pettycashData = response.data.data
        const pettyCashItems = response.data.pettyCashItems
        const bookingLogs = response.data.bookingLogs

        let pettyCashes = []
        if(downloadType === "pettyCash"){
            pettyCashes = constructPettyCashData(pettycashData, pettyCashItems, bookingLogs)
        }
        else if(downloadType === "product"){
            pettyCashes = constructProductData(pettycashData, pettyCashItems, bookingLogs)
        }

        if(dataFormat === "CSV"){
            let csv = Papa.unparse(pettyCashes, { download: true })
            let blob = new Blob([csv])
            let a = window.document.createElement("a")
            a.href = window.URL.createObjectURL(blob, { type: "text/plain" })
            a.download = downloadType === "pettyCash" ? "pettyCashDump.csv" : "pettyCashProductDump.csv"
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        }
        if(dataFormat === "XLSX"){
            const ws = utils.json_to_sheet(pettyCashes)
            const wb = utils.book_new()
            utils.book_append_sheet(wb, ws, 'Sheet1')
            const blob = new Blob([write(wb, { bookType: 'xlsx', type: 'array' })])
            const url = URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = downloadType === "pettyCash" ? "pettyCashDump.xlsx" : "pettyCashProductDump.xlsx"
            a.click()
            URL.revokeObjectURL(url)
        }
    }

    const downloadFormatOptions = [
        {
            label: "PettyCash XL",
            command: () => downloadData("XLSX", "pettyCash")
        },
        {
            label: "PettyCash CSV",
            command: () => downloadData("CSV", "pettyCash")
        },
        {
            label: "Product XL",
            command: () => downloadData("XLSX", "product")
        },
        {
            label: "Product CSV",
            command: () => downloadData("CSV", "product")
        }
    ]


    const handleCheckboxSelect = (event) => {
        let updatedSearchParams = {}
        if (event.target.checked){
            updatedSearchParams = {...searchParams, [event.target.name]: event.target.checked}
        } else{
            updatedSearchParams = {...searchParams, [event.target.name]: event.target.checked, pettyCashAccount: pettyCashAccount?.pettyCashAccountId}
        }
        dispatch(updateSearchParams(updatedSearchParams))
    }

    const handleSearchKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch()
        }
    } 

    const handleSearch = () => {
        const isUserPrimaryHolder = pettyCashAccount?.primaryHolder === usersData.userId
        let errorFound = false

        if (searchParams.searchText === "" && searchParams.searchBy !== "all") {
            dispatch(raiseToast({ severity: 'error', summary: normalizeLabel(searchParams.searchBy), detail: "Please enter search text" }))
            errorFound = true
        } 
        else if (searchParams.searchText && searchParams.searchBy !== "all"){
            const relatedSearchOption = searchConfig.find(eachOption => eachOption.name === searchParams.searchBy)
            if(relatedSearchOption.isValid && !relatedSearchOption.isValid(searchParams.searchText.split(";")[0])){
                dispatch(raiseToast({ severity: 'error', summary: normalizeLabel(searchParams.searchBy), detail: `Please enter valid ${normalizeLabel(searchParams.searchBy).toLowerCase()}` }))
                errorFound = true
            }
        }
        
        searchOptions.map(eachOption => { 
            if (["TEXT", "SELECT", "AUTO_COMPLETE"].includes(eachOption.type)) {
                if (!searchParams[eachOption.name] && searchParams[eachOption.name] !== false) {
                    const errorMsgText = normalizeLabel(eachOption.label)
    
                    dispatch(raiseToast({ severity: 'error', summary: errorMsgText, detail: `Please enter ${errorMsgText.toLowerCase()}` }))
                    errorFound = true
                } else {
                    if(eachOption.isValid && !eachOption.isValid(searchParams[eachOption.name].split(";")[0])){
                        const errorMsgText = normalizeLabel(eachOption.label)
                        dispatch(raiseToast({ severity: 'error', summary: errorMsgText, detail: `Please enter valid ${errorMsgText.toLowerCase()}` }))
                        errorFound = true
                    }
                }
            } 
        })

        let updatedSearchParams = {...searchParams}

        if(updatedSearchParams.searchBy !== "all"){
            updatedSearchParams[updatedSearchParams.searchBy] = updatedSearchParams.searchText.trim()
        }

        let updatedPettyCashAccount = pettyCashAccount?.pettyCashAccountId
        const {isPermitted: isPermittedToViewAllPettyCashes} = checkPermissions({...usersData, permissions: [200]}) 

        if (!searchParams.onlyMe && isPermittedToViewAllPettyCashes){
            updatedPettyCashAccount = null
        }
        updatedSearchParams = {
            ...updatedSearchParams, 
            // pettyCashAccount: updatedPettyCashAccount, 
            isUserPrimaryHolder: isUserPrimaryHolder
        }

        if (searchParams.searchBy === "kamName" || searchParams.kamName || searchParams.account){
            updatedSearchParams = {...updatedSearchParams, account: searchParams.account}
        }else{
            updatedSearchParams = {...updatedSearchParams, account: null}
        }

        if(!errorFound){
            dispatch(updateSearchParams(updatedSearchParams))
            dispatch(fetchPettyCash({...paginationParams, ...updatedSearchParams, pageNo: 0, pettyCashAccount: updatedPettyCashAccount}))
            getOpeningAndClosingBalances()
        }
    }

    const kamSearchMethod = (event) => {
        // console.log("event", event)
        if(event.query === ""){
            setKAMSuggestions([...pettyCashUsers])
        }
        else{
            const searchResults = kamFuzzSearch.search(event.query)
            // console.log("searchResults", searchResults)
            const relatedKams = searchResults.map(eachProduct => eachProduct.item)
            setKAMSuggestions(relatedKams)
        }

        getOpeningAndClosingBalances()
    }

    const {isPermitted: isAccountSearchPermitted} = checkPermissions({...usersData, permissions: [181]})

    const handleDateRangeChange = (range) => {
        const { fromDate, toDate } = getDateRange(range)
        getDateRange(range)
        dispatch(updateSearchParams({ ...searchParams, range, fromDate, toDate }))
    }

    return(
        <div className="p-card petty-cash-search-page" style={{border:"1px solid #e9ecef"}} onKeyDown={handleSearchKeyPress}>
            <div className="grid"> 
                {
                    searchOptions.map(eachOption => {
                        console.log("searc", eachOption)
                        if (eachOption.type === "SEARCH_TEXT") {

                            let searchByOptions = [{label: 'No Filters', value: 'all'}]
                            searchConfig.map(eachSearchBy => {
                                if (eachSearchBy.isSearchByOption) {
                                    const optionInUse = searchOptions.find(eachSearchOption => eachSearchOption.srNO === eachSearchBy.srNO)
                                    if(!optionInUse){
                                        searchByOptions.push({ label: eachSearchBy.label, value: eachSearchBy.name })
                                    }
                                }
                            })
    
                            return (
                                <>
                                    <div className="flex flex-column col-12">
                                        {['kamName'].includes(searchParams.searchBy) ? (
                                            <AutoCompleteField
                                                value={searchParams.searchText}
                                                suggestions={suggestions}
                                                searchMethod={(e) => autoCompleteSearch(searchParams.searchBy, e.query)}
                                                field="displayName"
                                                labelText="Search Text"
                                                onChange={handleSearchOnChange}
                                                name="searchText"
                                                dropdown
                                                refName={searchTextRef}
                                            />
                                        ) : (
                                            <TextInputField
                                                name="searchText"
                                                labelText="Search Text"
                                                placeholder="No Filter"
                                                refName={searchTextRef}
                                                value={searchParams["searchText"]}
                                                onChange={handleSearchOnChange}
                                            />
                                        )}
                                    </div>
                                    {searchParams.searchText && (
                                        <div className="flex flex-column col-12">
                                            <DropDownField
                                                name="searchBy"
                                                labelText="Search By"
                                                options={searchByOptions}
                                                value={searchParams["searchBy"]}
                                                onChange={handleSearchOnChange}
                                            />
                                        </div>
                                    )}
                                </>
                            )
                        }

                        if(eachOption.type === "DATE"){
                            return (
                                <>  
                                   <DateFilter 
                                        eachOption={eachOption} 
                                        searchParams={searchParams} 
                                        dateOptions={["MTD", "PM", "L15", "L30"]}
                                        handleDateRangeChange={handleDateRangeChange} 
                                        handleSearchOnChange={handleSearchOnChange}
                                        removeFilterOption={removeFilterOption}
                                    />
                                </>
                            )
                        }
                        if(eachOption.type === "SELECT"){
                            const updatedOptions = eachOption.options.map(eachSelectOption => ({label: eachSelectOption.label, value: eachSelectOption.value}))
                            return (
                                <>
                                    { !eachOption.static ? 
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={()=> removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                        :
                                        null 
                                    }
                                    <div className="flex flex-column col-12">
                                        <DropDownField name={eachOption.name} options={updatedOptions} labelText={eachOption.label} value={searchParams[eachOption.name]} onChange={handleSearchOnChange} />
                                    </div>
                                </>
                            )
                        }

                        if (eachOption.type === "TEXT") {
                            return (
                                <>
                                    {!eachOption.static &&
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={() => removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                    }
                                    {
                                        <div className="flex flex-column col-12">
                                            <TextInputField name={eachOption.name} labelText={eachOption.label} value={searchParams[eachOption.name]} onChange={handleSearchOnChange} />
                                        </div>
                                    }
                                </>
                            )
                        }

                        if (eachOption.type === "AUTO_COMPLETE") {
                            return (
                                <>
                                    {!eachOption.static &&
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={() => removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                    }
                                    {
                                        <div className="flex flex-column col-12">
                                            <AutoCompleteField
                                                value={searchParams[eachOption.name]}
                                                suggestions={suggestions}
                                                searchMethod={(e) => autoCompleteSearch(eachOption.name, e.query)}
                                                field="displayName"
                                                labelText={eachOption.label}
                                                onChange={handleSearchOnChange}
                                                name={eachOption.name}
                                                dropdown
                                            />
                                        </div>
                                    }
                                </>
                            )
                        }

                        if(eachOption.type === "MULTISELECT"){
                            return (
                                <>  
                                    { !eachOption.static ? 
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={()=> removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                        :
                                        null 
                                    }
                                    <div className="flex flex-column col-12 custom-multiselect">
                                        <MultiSelectField name={eachOption.name} labelText={eachOption.label} options={eachOption.options} value={searchParams[eachOption.name]} onChange={handleSearchOnChange} />
                                    </div>
                                </>
                            )
                        }
                    })
                }
                <div className="flex flex-column col-12">
                    <div className="flex flex-row justify-content-between">
                        <CheckboxField name="onlyMe" onChange={handleCheckboxSelect} checked={ searchParams.onlyMe } label="Only My Account" disabled={!isAccountSearchPermitted} />
                        <CheckboxField name="openIssues" onChange={handleCheckboxSelect} checked={searchParams.openIssues} label="Open Issues" />
                    </div>
                </div>
                <div className="flex col-12 justify-content-end">
                    <Menu model={addFilterOptions} popup ref={filterMenu} />
                    <Button icon="pi pi-filter" className="h-2rem p-2 action-btn hover:surface-300 hover:text-700" label="Add Filter" onClick={(e) => filterMenu.current.toggle(e)} />
                </div>

                <div className="flex flex-column col-12 mb-0 pb-0">
                    <div className="grid">
                        <div className="flex col-12 mb-0 gap-1 pb-0" style={{cursor : isLoading ? 'not-allowed' : 'pointer'}}>
                            <Button label="Search" style={{flexGrow: 1}} className="py-2" onClick={handleSearch} disabled={isLoading}/>
                            <Menu model={downloadFormatOptions} popup ref={downloadMenu} />
                            <Button icon="pi pi-download" className="py-2 px-3"  onClick={(e) => downloadMenu.current.toggle(e)} permissions={[244]}/>
                        </div>
                    </div>
                </div>
            </div>
            <Loading visible={loading} />
        </div>
    )
}

export default Search;